import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import styles from "./M2MProductSelector.module.scss";
import { M2MProductButton } from "./M2MProductButton";

export type M2MProductSelectorProps = {
  isOpen: boolean;
  onClose: () => void;
  pdpUrl: string;
};

export function M2MProductSelector({
  isOpen,
  onClose,
  pdpUrl,
}: M2MProductSelectorProps) {
  const curtainPdpUrl = pdpUrl;
  const romanBlindPdpUrl = `${curtainPdpUrl}?roman=true`;

  return (
    <Modal
      footer={false}
      isOpen={isOpen}
      onClose={onClose}
      title="Select a curtain or Roman blind"
    >
      <div data-testid="m2m-product-selector">
        <div className={styles.copy}>
          <span className={styles.copyFirstLine}>
            This fabric can be made into a curtain or a Roman blind.
          </span>
          <span className={styles.copySecondLine}>
            To continue, please select which product you would like:
          </span>
        </div>
        <div className={styles.buttons}>
          <M2MProductButton productUrl={curtainPdpUrl} isRoman={false} />
          <M2MProductButton productUrl={romanBlindPdpUrl} isRoman />
        </div>
      </div>
    </Modal>
  );
}
